import { Button } from '@/components/ui/button'
import Page from '@/components/ui/Page'
import Title from '@/components/ui/Title'
import { Phone, Mail, Linkedin } from 'lucide-react'

const Contact = () => {
  return (
    <Page>
      <div className="flex flex-row">
        <div className="flex flex-col items-center justify-center gap-4 flex-1/2 h-fit">
          <Title text="Contact" />
          <div className="flex flex-row gap-2 items-center border-2 w-fit p-4 border-[var(--color-text)] rounded-full">
            <Mail className="size-8" color="var(--color-text)" />
            <p className="text-xl font-bold">clareb0004@gmail.com</p>
          </div>
          <Button
            variant="ghost"
            className="w-fit h-fit px-0 rounded-full py-0 cursor-pointer"
            onClick={() =>
              window
                .open(
                  'https://www.linkedin.com/in/clare-beyboer-609b12319/',
                  '_blank',
                )!
                .focus()
            }
          >
            <div className="flex flex-row gap-2 items-center border-2 w-fit p-4 border-[var(--color-text)] rounded-full">
              <Linkedin className="size-8" color="var(--color-text)" />
              <p className="text-xl font-bold">LinkedIn</p>
            </div>
          </Button>
        </div>
      </div>
    </Page>
  )
}

export default Contact
